






























import Vue from 'vue'
import models from '@/mixins/models-mixin'
import groupMixin from '@/mixins/group-mixin'
import IListTile from '@/types/components/IListTile.interface'
import Group from '@/types/Group.interface'
import FilterButton from '@/components/FilterButton.vue'
import IListAction, { IListActionType } from '@/types/components/IListAction.interface'
import Button from '@/types/components/Button.interface'
import IListIcon, {
    IListBadge,
    IListIconType
} from '@/types/components/IListIcon.interface'
import { GroupFilterParams } from '@/types/FilterParams.interface'
import GroupSelector from '@/components/GroupSelector.vue'
import { mapGetters } from 'vuex'
export default Vue.extend({
    mixins: [models, groupMixin],
    components: { GroupSelector, FilterButton },
    data() {
        return {
            filter: {
                selected: {
                    display: 'All Groups',
                    key: 'filter',
                    value: 'all'
                },
                options: [
                    {
                        display: 'All Groups',
                        key: 'filter',
                        value: 'all'
                    },
                    {
                        display: 'Autoresponders',
                        key: 'filter',
                        value: 'autoresponders'
                    },
                    {
                        display: 'Static Groups',
                        key: 'filter',
                        value: 'static'
                    },
                    {
                        display: 'Filter Groups',
                        key: 'filter',
                        value: 'smart'
                    }
                ]
            },
            groupsListPlaceholder: {
                img: 'noGroups',
                content: 'No Groups Found'
            },
            //  Determines if we are showing the filter list or not
            filtered: false,
            //  Our temporary groups list
            filterResults: null,
            //  Determines if we are showing the search results list or not
            searched: false,
            //  Our temporary groups list
            searchResults: null,
            //  Determines if the DOM has finished mounting
            mounted: false,
            toolbar: {
                title: 'Groups',
                help: {
                    title: 'Sort and Organize Contacts into Groups',
                    body: "Here is where you'll manage all your Groups. A Group is a collection of Contacts you've made. MessageDesk allows for multiple different types of groups - Simple, Filter, Autoresponder, and Forms. You can learn how to create a Group in the article below:",
                    button: {
                        text: 'Learn More',
                        link: `${process.env.VUE_APP_URL_LEARN}/en/articles/5407846-how-to-create-a-group-in-messagedesk`
                    }
                }
            }
        }
    },
    mounted() {
        this.mounted = true
    },
    computed: {
        ...mapGetters({
            defaultParams: 'listsGroupsDefaultParams',
            groupsLoading: 'groupsLoading',
            isApp: 'isApp',
            optOutGroup: 'optOutGroup',
            userHasPermission: 'userHasPermission'
        }),
        //  We display our groups list UNLESS we are searching, in which case we just use a temp list
        groups(): Group[] {
            //  If we have filtered, then display our filtered list
            if (this.filtered) return this.filterResults
            //  If we are searching then display our temporary list
            else if (this.searched) return this.searchResults
            //  Else, just display the listsGroups
            else return this.$store.getters.listsGroups
        },
        groupsEnabled() {
            return this.$store.getters.getEnabled('group')
        },
        groupsIList() {
            return this.$store.getters.iList('listsGroupsList')
        },
        groupsParams: {
            get(): GroupFilterParams {
                return this.$store.getters.listsGroupsParams
            },
            set(val: GroupFilterParams): void {
                this.$store.commit('listsGroupsParamsSet', val)
            }
        },
        listLoading(): boolean {
            //  Our IList should be in a loading state if we are loading our groups AND
            //  we don't have any groups because this is our initial loading state
            return this.groupsLoading && !this.groups.length
        },
        //  Return an array of multi-selected groupIDs
        multiSelectedGroupIds(): number[] {
            //  If the groupsIList does NOT exist, return empty array
            if (!this.groupsIList) return []

            //  Assemble an array of multi-selected group ids
            const ids = this.groupsIList.multiSelected.map((group: Group) => group.id)

            //  Return the group ids
            return ids
        },
        operator(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            return window.getProps(role, ['name']) === 'Operator'
        },
        tools(): Button[] {
            //  Check if we have anything selected
            const selected = this.groupsIList && this.groupsIList.multiSelect

            //  Create our create button
            const defaultBtn: Button = {
                text: 'Create Group',
                icon: 'mdi-account-multiple-plus',
                disabledPopup: this.operator,
                disabledPopupText:
                    "You don't have permission to access this feature. Please contact your account's admin to perform this task or have them update your account permission",
                callback: () => this.$router.push('/groups/create')
            }
            //  Create our multi button
            const multiBtn: Button = {
                text: 'Delete Group(s)',
                icon: 'bi-trash-fill',
                disabled: !this.multiSelectedGroupIds.length,
                disabledPopup: this.operator,
                disabledPopupText:
                    "You don't have permission to access this feature. Please contact your account's admin to perform this task or have them update your account permission",
                callback: () => this.deleteGroups()
            }

            //  If we aren't selected, return our default tools
            if (!selected) return [defaultBtn]
            //  Else, return the multi select tools
            else return [multiBtn]
        }
    },
    methods: {
        //  Applies our filter to our current list of groups
        applyFilter(params: GroupFilterParams): Group[] {
            // Grab our current list of groups
            const groups = this.$store.getters.listsGroups

            //  Grab the value from our params
            const val = params.value

            //  Get our filter from the params
            const filter = {
                all: () => true,
                autoresponders: (group: Group) => group.campaign_id != null,
                smart: (group: Group) => group.query !== null,
                static: (group: Group) => group.query === null
            }

            //  Apply our filter
            const filtered = groups.filter((x: Group) => filter[val](x))

            //  Return our filtered list
            return filtered
        },
        //  Delete multiple groups
        async deleteGroups(): Promise<void> {
            //  Get the selected groups
            const groups = this.groupsIList.multiSelected

            //  Remove all required groups
            const filtered = groups.filter((x: Group) => !x.required)

            //  Get confirmation from the user
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Delete Groups?',
                icon: 'bi-trash-fill',
                text: `Are you sure you want to delete ${filtered.length} group(s)?`,
                callback: async (result) => {
                    //  If the user answered 'NO' do nothing
                    if (!result) return

                    //  Assemble selected group ids for our request payload
                    const ids = filtered.map((x) => x.id)

                    //  Delete the groups
                    const response = await this.$store.dispatch('groupsDeleteBatch', ids)

                    //  If the request failed, do nothing
                    if (!response) return

                    // Notify the user of success
                    this.$store.commit('appNotificationBarSet', {
                        message: `${filtered.length} group(s) deleted`
                    })

                    //  Reset our checkbox
                    this.$refs.groupsList.multiSelectReset()
                }
            })
        },
        //  Navigate to the group's profile
        goToGroup(group: Group): void {
            //  Navigate to the group
            this.$router.push(`/groups/${group.id}?sender=${this.$route.path}`)
        },
        //  The actions available in the IListTile for a group
        groupActions(group: Group): IListAction {
            //  Else, create our buttons
            const menu: Button[] = [
                {
                    icon: 'mdi-bullhorn',
                    text: 'Send Broadcast',
                    color: 'primary',
                    callback: () => this.goToBroadcastCreate(group),
                    disabledPopup: this.operator,
                    hidden: group.id == this.optOutGroup.id
                },
                {
                    icon: 'mdi-square-edit-outline',
                    text: 'Edit group',
                    color: 'primary',
                    callback: () => this.goToGroupEdit(group),
                    disabledPopup: this.operator,
                    hidden: group.required
                },
                {
                    icon: 'mdi-content-copy',
                    text: 'Copy group',
                    color: 'primary',
                    callback: () => this.groupCopy(group),
                    disabledPopup: this.operator,
                    hidden: !group.persons_count
                },
                {
                    icon: 'bi-download',
                    text: 'Export group',
                    color: 'primary',
                    callback: () => this.groupExport(group),
                    disabledPopup: this.operator
                },
                {
                    icon: 'bi-trash-fill',
                    text: 'Delete Group',
                    color: 'primary',
                    callback: () => this.groupDelete(group),
                    disabledPopup: this.operator,
                    hidden: group.required
                }
            ]

            //  If this is the mobile app, remove 'export group'
            if (this.isApp || this.$store.getters.isMobile()) menu.splice(3, 1)

            //  Create our IListAction
            const action: IListAction = {
                type: IListActionType.menu,
                menu: menu
            }

            //  Return the assembled actions
            return action
        },
        //  The IListIcon bound to the groups list
        groupIcon(group: Group): IListIcon {
            //  Get our icon from the vue filter
            const icon = this.$options.filters.groupIcon(group)

            //  Get our badge icon
            const badgeIcon = this.$options.filters.groupBadge(group)

            //  Get our badge
            const badge: IListBadge = {
                color: 'primary',
                icon: badgeIcon
            }

            //  Create our IListIcon object
            const listIcon: IListIcon = {
                type: IListIconType.icon,
                content: icon,
                color: 'primary'
            }

            //  If we have a badge icon, add badge to our ilisticon
            if (badgeIcon) listIcon.badge = badge

            //  Return our IListIcon object
            return listIcon
        },
        groupsTile(): IListTile {
            return {
                actionContent: (group: Group) => this.groupActions(group),
                leftFooter: (group: Group) => this.$options.filters.groupType(group),
                leftIcon: (group: Group) => this.groupIcon(group),
                line1: (group: Group) => group.name,
                line3: (group: Group) => this.$options.filters.groupPersonsCount(group),
                callback: (group: Group) => this.goToGroup(group),
                multiSelectHide: (group: Group) => (group.required == true ? true : false)
            }
        },
        //  Occurs when the filter is applied
        onFilterChanged(params: GroupFilterParams): void {
            //  Check if the applied filter is the same as current filter
            const isSame = window._.isEqual(this.groupsParams, params)

            //  If the filter is the same then do nothing
            if (isSame) return

            //  Else, update our store params
            this.groupsParams = params

            //  Check if the applied filter is the default
            const isDefault = window._.isEqual(this.defaultParams, params)

            //  If it is default, then clear our filtered and list
            if (isDefault) {
                this.filtered = false
                this.filterResults = null
                return
            }

            //  We don't paginate groups so we just need to filter our actual list
            const filtered = this.applyFilter(params)

            //  Set our temporary list
            this.filterResults = filtered

            //  Set filtered to true to display our new list
            this.filtered = true
        },
        //  Remove items in groupsList and set showLoad to true
        onSearchCleared(): void {
            //  Set our search bool to false
            this.searched = false

            //  Set our temporary groups list to empty
            this.searchResults = null
        },
        //  Replace items in the groupsList, with search results
        onSearchCompleted(groups: Group[]): void {
            //  Set our temporary groups list to the groups we found
            this.searchResults = groups

            //  Set our search bool to true
            this.searched = true
        }
    }
})
